(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5966],{

/***/ 1503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/ebay-seller-protection/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-02-22",
      tag: "eBay",
      title: "The Basics of eBay Seller Protection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How eBay Seller Protection works"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The main goal of eBay Seller Protection is to protect the best interests of all its users. eBay seller protection is an excellent service for sellers to use if they are not 100% confident in their transactions. Although eBay sellers are protected by eBay policies, transaction monitoring, and data systems, it is still good to know that your hard-earned money and item are protected when something goes wrong.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The eBay seller protection works in three ways. Through customer service, buyer practices policy, and eBay seller protection policy. We will go over it one by one.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Customer Service "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay customer service works round the clock to attend to all your needs and answer common problems. They have a Frequently Asked Questions (FAQs) tab to help you find answers to some of the common issues that users encounter on the platform.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The following are categories you can choose from: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Selling"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Buying"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Account"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Shipping and Tracking "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Return & Refunds "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Fees & Billings "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If none of these are helpful, you can also ask questions to the eBay", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://community.ebay.com/t5/forums/postpage/board-id/ask-a-mentor",
          children: "community"
        }), ". In this way, you can get insights and opinions from your fellow users.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Buyer Practice Policy"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["To identify abusive buyer behavior, you must first learn their policies too. Their policy is never to misuse feedback, returns, buyer protection programs, or payment dispute processes.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Suppose a buyer is asking for unreasonable demands or practicing abusive buying behavior. In that case, you may report them ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://spd.ebay.com/RBASellerHub",
          children: "here"
        }), ". eBay seller doesn't need to compromise with buyers' harsh demands not stated on their original listing terms.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Additionally, eBay sellers are protected against lousy feedback or defects (if they shipped the purchased items) or decide to cancel the transaction. However, eBay still recommends that the seller communicates to its buyers politely and professionally.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["To learn more if a buyer is showing abusive behavior or making unreasonable demands, here are some of the common abusive buyer behavior activities you should watch out for:", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Abusive Behavior Activity "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The following are abusive behaviors that eBay doesn't allow inside the platform: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Buyers make unreasonable demands or ask for extras not offered in the original listing or seller's terms.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Buyers make false claims by claiming an item was not received when proof of delivery to the address was issued on the order details page.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Buyers are misusing returns and refunds. The buyer returns an item other than the item initially received, using or damaging the item before returning it, or returning an item due to misrepresenting when it was described accurately.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Buyers are misusing eBay messaging to harass or intimidate the seller into something outside the original listing terms."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Buyers are abusing eBay's buyer protection program by harassing sellers about the item's delivery not yet past the latest estimated delivery date.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Buyers are abusing payment service and dispute processes by filing duplicate requests or excessive payment disputes.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Buyers not paying winning bid items within four calendar days"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If the buyers fail to follow these standards, action will be taken against them, such as account limits or losing buying privileges. These are imposed to protect eBay sellers against abusive behaviors or fraudulent acts.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "eBay Seller Protection Policy "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay seller protection is an integral part of the eBay marketplace. It protects sellers from potential buyers who are abusive or trying to scam them out of their hard-earned money."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay will also remove any negative or neutral feedback and defects when something goes wrong beyond their control. This includes severe weather or carrier disruptions causing the items to arrive late.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Protections for TRS (Top Rated Sellers) "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay knows how vital ratings and feedback are for top-rated sellers. They have imposed added protection for their top-performing sellers. Items listed by TRS living in the U.S. or Canada who offer 30 days or more extended returns are protected when:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "The buyer is claiming for the item to be misrepresented "
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "To qualify: "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "The seller must report the transaction and buyer to eBay "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "eBay will investigate if the buyer is claiming falsely "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "If the report qualifies, eBay will subsidize the return shipping label up to $6.00 per return"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Credit will be credited on the seller's monthly invoice"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: ["Any negative or neutral feedback, including opened cases in service metrics, will be automatically removed.", ' ']
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "The buyer used or damaged then returned the item. "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["If the report qualifies, the seller can deduct up to 50% from the refund to cover the lost value of the returned item. If the seller wants eBay to step in and resolve the problem, the seller may no longer issue a partial refund to the buyer.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "If agreed upon, eBay will work directly with the buyer to resolve any issues associated with the returned item. This includes negative and neutral feedback, defects, and open cases in service metrics."
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Refunding the Buyer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If the seller agreed to give the buyer a partial or full refund after the item has been returned. Simply follow these steps:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to \"returns dashboard.\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on the transaction and choose \"refund buyer.\""
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The seller must issue a refund within two business days after the item has been returned. If the seller fails to issue a refund after two business days, eBay will automatically issue a refund on behalf of the seller.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If the refund process is successful: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["The amount will be automatically refunded on the buyer's original payment method. The refund usually takes 3 to 5 business days. However, depending on the buyer's bank processing time, some take up to 30 days.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["The returned item will automatically be relisted. In the event that the seller no longer wants to relist the item, just uncheck the \"relist item box\" when issuing a refund.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["You may qualify for a fee credit - After you issue a full refund to the buyer, you may check this", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.ebay.com/help/selling/fees-credits-invoices/fee-credits?id=4128",
            children: "link"
          }), " to see if you are eligible for a credit to your final value fee and other charges.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Other Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay seller protection is an essential aspect of selling on eBay. Sellers are responsible for all aspects of their listings, including shipping and handling costs. But if a buyer does not receive the item they purchased or claims to have received it damaged, eBay will step in to make sure the seller will not be compromised. The following are other seller protection imposed by eBay.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Seller Performance Standards "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Your performance matters. This is why eBay measures your overall performance as accurately as possible. In the event that unwanted circumstances happen, your performances are protected.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Transaction defect rate won't count unless you have transactions with defects reported by at least four different buyers within the evaluation period."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Seller is not subjected to Service Metrics of a rate under 1% in a specific category. This also includes sellers with fewer than 10 \"item not as described\" or \"Item not received\" reported by different buyers.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Defect rates are only visible to the seller's end. Buyers cannot see your transactions with defect ratings.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "eBay Money Back Guarantee "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay has a money-back guarantee for cases such as a buyer reporting an \"I did not receive the item\" or \"The item received isn't as described.\" Any negative and neutral feedback and defects will be automatically removed if the appeal request is in the seller's favor.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The \"I haven't received my order\" reports will only qualify for a money-back when: "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The seller ships the item promptly (within the stated handling time) alongside proof of its tracking number and estimated delivery date. It should be shipped from one of eBay's integrated shipping carriers and must have evidence of successful delivery under the \"order details\" page."
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The \"My items aren't as described\" reports will only qualify for a money-back when: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["The seller is protected against negative and neutral feedback only if they offer free returns, accept the buyer's return request, and provide a refund.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["In cases wherein the buyer requested a return but did not provide proof of shipment for the returned item, the seller is protected against negative or neutral feedback. eBay will automatically remove any input associated with that transaction once the case is closed.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Buyers with Duplicate Claims "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay protects its seller against buyers making unreasonable demands and unacceptable buying behavior. The buyer can only choose one resolution method and wait for the duration of the process. In case they open an eBay Money Back Guarantee request and open an order cancellation request or open a return request under the same transaction. The case will immediately be closed.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Seller Eligibility Protection "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The following are criteria for eBay sellers to qualify for seller protection. The seller will not be eligible for seller protection and claims if they fail to comply with the following:", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Selling with a false identity. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Not adhering to the service promises (not honoring return policy, not issuing refunds) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Has a history of a severe policy violation (selling counterfeits, selling prohibited items)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Misusing seller protection (Giving unjust or low partial refund) "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In comparison, if you are one of the top-rated sellers of eBay, you must adhere to the following to qualify for Top-Rate Seller Protection.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Become one of the U.S. Rated Seller at the time of requested protection "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The TRS must be residing in the U.S. or Canada (including U.S. Territories) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The TRS must offer 30 day or more extended returns."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The TRS must provide partial refunds only to get the loss value of the returned item. "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["The TRS must report buyers falsely claiming that they received an item that isn't as described when you send the correct item.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The TRS must not be rated \"Very High\" in their service metrics. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay has a large-scale system that helps resolve problems before they begin. Although the system isn't perfect all the time, it can still easily detect anomalies or suspicious activities. Most of the transactions inside eBay are covered by seller protection.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The transaction will only be not eligible for any protections if you violate any of eBay's policies, such as selling prohibited or restricted items or listing categories excluded from eBay's money-back guarantee.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Final thoughts"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay dedicates a team solely responsible for protecting sellers against scams and fraudulent acts. Aside from its seller protection team, its system also operates 24/7 to prevent problems before they arise. One of the good things about eBay's seller protection policy is that they know how valuable each seller's time is.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Just like how eBay protects its sellers against abusive or fraudulent acts, OneShop also watches and helps our clients have a smooth and seamless reselling business. Whether you have an account on Poshmark, Depop, Mercari, or eBay, we help you make your work easier and faster. Our bots can do all the manual labor such as liking, sharing, following, and relisting, so you won't have to.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["And on top of it, we offer a 7-day free trial with no commitment and credit card required. Simply sign up", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "here"
        }), ", and our attentive support team will guide you through the whole process. Visit ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/",
          children: "https://tools.oneshop.com/"
        }), " to learn more.", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/ebay-seller-protection.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "The Basics of eBay Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Learn how eBay seller protection works, what constitutes abusive buyers, and the requirements for a seller to qualify for protection."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/ebay-seller-protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/ebay-seller-protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "The Basics of eBay Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Learn how eBay seller protection works, what constitutes abusive buyers, and the requirements for a seller to qualify for protection."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 67542:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ebay-seller-protection",
      function () {
        return __webpack_require__(1503);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(67542); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);